<section class="w-full fb-filter flex flex-col justify-center items-center">
	<h3 class="text-xl font-bold mt-2 text-[#1e1e1e] capitalize text-center">{{storyTitle.toLowerCase()}} Products</h3>
	<fb-filter-body class="w-full max-w-[1290px]" [data]="filterData" [storyId]="storyId"></fb-filter-body>
</section>
